import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Marcus Johnson',
    location: 'Austin, TX',
    date: '2 weeks ago',
    text: 'ProRoof replaced our entire roof in just 3 days. The crew was professional, cleaned up everything, and the new roof looks incredible. Best home investment we have made.'
  }, {
    name: 'Sarah Mitchell',
    location: 'Round Rock, TX',
    date: '1 month ago',
    text: 'After the hailstorm, ProRoof handled our entire insurance claim. Zero stress on our end. They even found damage we did not know about during the inspection.'
  }, {
    name: 'David & Lisa Chen',
    location: 'Cedar Park, TX',
    date: '2 months ago',
    text: 'We got quotes from 5 companies. ProRoof was not the cheapest, but their transparency and warranty made the decision easy. Absolutely worth every penny.'
  }, {
    name: 'Jennifer Ramirez',
    location: 'Georgetown, TX',
    date: '3 months ago',
    text: 'From the first call to the final walkthrough, everything was seamless. Our neighbors have already asked for their number. Cannot recommend them enough.'
  }, {
    name: 'Robert Thompson',
    location: 'Pflugerville, TX',
    date: '4 months ago',
    text: 'Had a leak that two other companies could not fix. ProRoof diagnosed the issue in 20 minutes and had it repaired the same day. True professionals.'
  }, {
    name: 'Amanda Foster',
    location: 'Lakeway, TX',
    date: '5 months ago',
    text: 'The lifetime warranty sold us, but the quality of work exceeded our expectations. Our home looks brand new. Thank you, ProRoof team!'
  }];
  return <section className="py-16 md:py-24 bg-background" data-id="element-293">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
        <div className="text-center mb-16" data-id="element-295">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6" data-id="element-296">
            Don't Take Our Word For It
          </h2>

          <div className="inline-flex flex-col items-center justify-center p-6 bg-slate-50 rounded-2xl border border-border" data-id="element-297">
            <div className="flex items-center gap-2 mb-2" data-id="element-298">
              <span className="text-5xl font-extrabold text-foreground" data-id="element-299">
                4.9
              </span>
              <div className="flex flex-col items-start" data-id="element-300">
                <div className="flex text-amber-500" data-id="element-301">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" data-id="element-302" />)}
                </div>
                <span className="text-sm font-medium text-muted-foreground mt-1" data-id="element-303">
                  200+ Verified Reviews
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-304">
          {reviews.map((review, index) => <div key={index} className="bg-card border border-border rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-305">
              <div className="flex text-amber-500 mb-6" data-id="element-306">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" data-id="element-307" />)}
              </div>
              <p className="text-foreground text-lg mb-8 italic" data-id="element-308">
                "{review.text}"
              </p>
              <div className="mt-auto" data-id="element-309">
                <p className="font-bold text-foreground" data-id="element-310">{review.name}</p>
                <p className="text-sm text-muted-foreground" data-id="element-311">
                  {review.location} • {review.date}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}